import type { IconSvgObject } from './types';

const HonorIcon: IconSvgObject = [
  ["path", { d: "M2.5 3H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.5 2.99805L4.5 15.9789L11.9363 20.981C11.97 21.0037 12.0141 21.0037 12.0478 20.9811L19.5 15.9789V2.99805", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 13H9.5M14.5 8H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HonorIcon;
